import gql from 'graphql-tag';
import { alarmScheduleMutationResponseFields } from './fragments';

export const setAlarmScheduleControl = gql`
  mutation setAlarmScheduleControl($condominiumId: Int!, $enabled: Boolean!) {
    setAlarmScheduleControl(condominiumId: $condominiumId, enabled: $enabled) {
      result
    }
  }
`;

export const createAlarmScheduleTable = gql`
  mutation createAlarmScheduleTable($data: CreateAlarmScheduleTableInput!) {
    createAlarmScheduleTable(data: $data) {
      ...AlarmScheduleMutationResponseFields
    }
  }
  ${alarmScheduleMutationResponseFields}
`;

export const updateAlarmScheduleTable = gql`
  mutation updateAlarmScheduleTable(
    $id: Int!
    $data: UpdateAlarmScheduleTableInput!
  ) {
    updateAlarmScheduleTable(id: $id, data: $data) {
      ...AlarmScheduleMutationResponseFields
    }
  }
  ${alarmScheduleMutationResponseFields}
`;

export const deleteAlarmScheduleTable = gql`
  mutation deleteAlarmScheduleTable($id: Int!) {
    deleteAlarmScheduleTable(id: $id) {
      result
    }
  }
`;

export const assignAlarmScheduleTable = gql`
  mutation assignAlarmScheduleTable($data: AssignAlarmScheduleTableInput!) {
    assignAlarmScheduleTable(data: $data) {
      ...AlarmScheduleMutationResponseFields
    }
  }
  ${alarmScheduleMutationResponseFields}
`;

export const removeAlarmScheduleTableAssignment = gql`
  mutation removeAlarmScheduleTableAssignment($id: Int!) {
    removeAlarmScheduleTableAssignment(id: $id) {
      result
    }
  }
`;

export const createAlarmScheduleTableWithAssignment = gql`
  mutation createAlarmScheduleTableWithAssignment(
    $data: CreateAlarmScheduleTableWithAssignmentInput!
  ) {
    createAlarmScheduleTableWithAssignment(data: $data) {
      result
      tableId
      assignmentId
    }
  }
`;

export const updateAlarmScheduleTableWithAssignment = gql`
  mutation updateAlarmScheduleTableWithAssignment(
    $id: Int!
    $data: UpdateAlarmScheduleTableWithAssignmentInput!
  ) {
    updateAlarmScheduleTableWithAssignment(id: $id, data: $data) {
      result
      tableId
      assignmentId
    }
  }
`;
